module.exports = __webpack_public_path__ + "img/Home_Icon.ef500254.png";